export const _super = {
  'images': [],
  'mainFeatures': [
    'Nano Graphite Coating with Nature Rubber',
    'Automated Assembling Production with Reasonable Price'
  ],
  'material': [
    'Rubber: Nature Rubber',
    'Frame: SGCC, Electrostatic Powder Coating',
    'Rivet: Steel Rivet',
    'Plastic (Spacer & Adapter): POM ',
    'Stainless Steel Backing: SUS430'
  ],
  'featureIcons': ['01', '03'],
  'otherFeatures': ["01", "02"],
  'specification': [
    { 'inch': 10, 'mm': 255, 'claw': 4, 'width': 6, 'thickness': 0.7 },
    { 'inch': 11, 'mm': 280, 'claw': 4, 'width': 6, 'thickness': 1.0 },
    { 'inch': 12, 'mm': 300, 'claw': 4, 'width': 6, 'thickness': 1.0 },
    { 'inch': 13, 'mm': 325, 'claw': 4, 'width': 6, 'thickness': 1.0 },
    { 'inch': 14, 'mm': 350, 'claw': 4, 'width': 6, 'thickness': 1.0 },
    { 'inch': 15, 'mm': 375, 'claw': 4, 'width': 6, 'thickness': 1.0 },
    { 'inch': 16, 'mm': 400, 'claw': 4, 'width': 6, 'thickness': 1.0 },
    { 'inch': 17, 'mm': 425, 'claw': 6, 'width': 6, 'thickness': 1.0 },
    { 'inch': 18, 'mm': 450, 'claw': 6, 'width': 6, 'thickness': 1.0 },
    { 'inch': 19, 'mm': 475, 'claw': 6, 'width': 6, 'thickness': 1.0 },
    { 'inch': 20, 'mm': 500, 'claw': 6, 'width': 6, 'thickness': 1.0 },
    { 'inch': 21, 'mm': 530, 'claw': 8, 'width': 6, 'thickness': 1.0 },
    { 'inch': 22, 'mm': 560, 'claw': 8, 'width': 6, 'thickness': 1.0 },
    { 'inch': 23, 'mm': 580, 'claw': 8, 'width': 6, 'thickness': 1.0 },
    { 'inch': 24, 'mm': 600, 'claw': 8, 'width': 6, 'thickness': 1.0 },
    { 'inch': 26, 'mm': 650, 'claw': 8, 'width': 8, 'thickness': 1.2 },
    { 'inch': 28, 'mm': 700, 'claw': 8, 'width': 8, 'thickness': 1.2 },
  ],
  "adapters": ["a7", "b", "b1", "b3", "c", "c1", "d2", "d4", "f", "g1", "p", "pc", "s", "s1", "tc", "f3"]
}
